import { Component } from '@angular/core';
import { FormControlDirective, FormControlName } from '@angular/forms';
import { Router } from '@angular/router';
import { AuthService } from 'ng-shared-library';

// attach a custom nativeElement property to all FormControl objects
const originFormControlNgOnChanges = FormControlDirective.prototype.ngOnChanges;
FormControlDirective.prototype.ngOnChanges = function () {
  this.form.nativeElement = this.valueAccessor._elementRef
    ? this.valueAccessor._elementRef.nativeElement
    : null;
  return originFormControlNgOnChanges.apply(this, arguments);
};

const originFormControlNameNgOnChanges = FormControlName.prototype.ngOnChanges;
FormControlName.prototype.ngOnChanges = function () {
  const result = originFormControlNameNgOnChanges.apply(this, arguments);
  this.control.nativeElement = this.valueAccessor._elementRef
    ? this.valueAccessor._elementRef.nativeElement
    : null;
  return result;
};

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: false
})
export class AppComponent {
  constructor(
    private authService: AuthService,
    private router: Router
  ) {
    this.authService.isLoggedIn().subscribe(resp => {
      if (
        !resp &&
        !router.url.startsWith('/authenticate') &&
        !router.url.startsWith('/register') &&
        !router.url.startsWith('/errorHandlingTest')
      ) {
        this.authService.startAuthentication();
      }
    });
  }

  hasRoute(route: string) {
    return this.router.url.includes(route);
  }
}
